import { Provider } from 'react-redux';
import { store } from '../../state';
import { useNavigate } from 'react-router-dom'; // Import useHistory from react-router-dom
import Wrapper from "../../components/Wrapper";
import { useEffect, useState  } from 'react'; // Import useEffect
import { API_URL} from "../../components/constants";
import { useUserContext } from '../../components/UserContext';
import axios from 'axios';
import { Race } from '../../models/race';

interface RacesProps {
  msisdn: string, // Define the msisdn prop type
  bal:number,
  minBal:number,
}

const Races: React.FC<RacesProps> = ({ msisdn,bal, minBal }) => {

  const [races, setRaces] = useState([]);
  const [raceAmount, setRaceAmount] = useState('');
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const navigate = useNavigate();
  const {defaultMinBal, defaultBal,  setDefaultRace  } = useUserContext();
  // Utilize the msisdn prop
  useEffect(() => {
    //console.log('msisdn in Races:', msisdn);
    // You can perform actions based on the msisdn value here
  }, [msisdn]); // Add msisdn to the dependency array if used in useEffect

  useEffect(  () =>{
    (
     async () => {
        try {
            const {data} = await axios.get(`${API_URL}/race`); 
             setRaces(data.data);
             setLastPage(data.meta.last_page);
            
        } catch (error) {
            
             
        }
        
     }
    )();
  }, [page]);

  const submit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
  }

  const handleRaceChange = async (e:  React.ChangeEvent<HTMLSelectElement>) => {
    const selectedAmount = e.target.value;
    setRaceAmount(selectedAmount);
    setDefaultRace( parseInt(selectedAmount, 10));
    //post user race
    try {
  
      const { data } = await axios.post(`${API_URL}/userRace`, {
        "msisdn": msisdn?.toString() || "", 
        "current_race": parseInt(selectedAmount, 10)
      });

      //console.log(data);
   
      if(data.current_race?.toString() || "" === selectedAmount) {      
        //handle success
         // Navigate to a different page with the selected value as a parameter
        navigate(`/?raceAmount=${selectedAmount}`);
      }else{
        //handle fail
        console.log("Data receipt fail");
      }
  
       // console.log(data);
     
    } catch (error) {
      console.error('Race request Failed:', error);
       
    }
    
   
  };
  

  return (
    <Wrapper msisdn={msisdn}> {/* Pass down the msisdn prop to Wrapper */}
      <Provider store={store}>
      <form onSubmit={submit}>
      {/* <div className="container bg-lime-400 h-screen opacity-70 place-items-center "> */}
        <div className="container bg-yellow-400 h-screen opacity-70 place-items-center">
        <div className='flex items-center justify-center h-screen bg-black rounded-md shadow-md m-2' > 
         <div className="flex flex-col items-center">
              {/* Div showing default balance */}
            <div className="bg-gray-800 text-white p-2 rounded-md mb-4">
                      {/* Your content */}
                    Bal: <span className='text-5xl'>{defaultBal}</span><p/>
                    Available: {defaultMinBal} <p/>
            </div>
        
            Copy code
<div className="mx-8 bg-white p-4 rounded-lg shadow-md flex flex-col sm:flex-row items-center justify-center gap-y-2 w-74 h-16">
              
              <select  className="border font-extrabold border-gray-300 rounded-md px-3 py-2 mr-2 focus:outline-none"
               onChange={handleRaceChange}
              >
              <option value='0'>Choose Race</option>
              {races.map((race: Race)=>{
                        return(
                            <option key={race.id} value={race.amount}>
                                 
                                 {race.amount} 
                                
                            </option>
                        );

                    })
                    }
              </select>
              
                    
            </div>
          </div>
          </div>
        </div>
        </form>
      </Provider>
    </Wrapper>
  );
};

export default Races;